import uuid from 'uuid';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { PanelGroup } from 'react-bootstrap';
import WizardFormStepOne from './WizardFormStepOne';
import WizardFormStepTwo from './WizardFormStepTwo';
import WizardFormStepThree from './WizardFormStepThree';
import WizardFormStepFour from './WizardFormStepFour';
import { setLoader, removeLoader } from '../../../../actions';
import { AdvertiserApi } from '../../../../api';
import { convertDollarsToMills } from '../../../../utils/helpers/currency';

class WizardForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createdCampaignInfo: {},
      selected: [],
    };
  }

  onFormSubmit(values) {
    const { next, dispatch, account } = this.props;
    const { selected } = this.state;
    const campaign = {
      ...values,
      bid_type: 'cpc',
      budget: convertDollarsToMills(values.budget.toFixed(2)),
      bid: convertDollarsToMills(values.bid.toFixed(2)),
      status: 'active',
    };

    const params = { account_id: account.uuid };

    dispatch(setLoader('campaignWizardForm'));

    dispatch(
      AdvertiserApi.actions.standardCampaignCreate.post(params, campaign, (error, success) => {
        if (success) {
          const campaignData = success.data;
          const ads = selected.map(j => {
            const formattedJob = {
              title: j.title,
              description: j.description,
              location: `${j.postalcode}, ${j.city}, ${j.state}, ${j.country}`,
              company: j.company,
              referencenumber: uuid.v4(),
              category: j.category,
              date: j.date,
              url: j.url,
            };
            return j.bid === null || j.bid === 0 ? formattedJob : { ...formattedJob, bid: j.bid };
          });
          Promise.all(
            ads.map(ad => {
              const args = {
                account_id: account.uuid,
                campaign_id: success.data.id,
                ad_format: 'text',
                ...ad,
              };
              return dispatch(AdvertiserApi.actions.adCreate.post(args));
            }),
          ).then(() => {
            dispatch(removeLoader('campaignWizardForm'));
            this.setState({ createdCampaignInfo: campaignData });
            dispatch(reset('campaignWizardForm'));
            next();
          });

          if (error) {
            dispatch(removeLoader('campaignWizardForm'));
          }
        }
      }),
    );
  }

  onSelectJobs(row, isSelected) {
    if (isSelected) {
      this.addJob(row);
    } else {
      this.removeJob(row);
    }
  }

  onSelectAllJobs(isSelected, jobs) {
    if (!isSelected) {
      this.removeAllJobs();
    } else {
      this.addAllJobs(jobs);
    }
  }

  addJob(job) {
    this.setState({
      selected: [...this.state.selected, job].sort(),
    });
  }

  removeJob(job) {
    this.setState({
      selected: this.state.selected.filter(item => {
        return item.referencenumber !== job.referencenumber;
      }),
    });
  }

  addAllJobs(jobs) {
    this.setState({ selected: [...this.state.selected, ...jobs].sort() });
  }

  removeAllJobs() {
    this.setState({ selected: [] });
  }

  render() {
    const { page, prev, next, account, hasCard, handleAddCard } = this.props;
    const { createdCampaignInfo, selected } = this.state;

    return (
      <PanelGroup id="panel-instructions">
        {page === 1 && <WizardFormStepOne onClick={next} step={page} account={account} />}
        {page === 2 && (
          <WizardFormStepTwo
            onSubmit={next}
            prev={prev}
            account={account}
            onSelectAllJobs={this.onSelectAllJobs.bind(this)}
            onSelectJobs={this.onSelectJobs.bind(this)}
            selected={selected.map(x => x.referencenumber)}
          />
        )}
        {page === 3 && <WizardFormStepThree onSubmit={this.onFormSubmit.bind(this)} prev={prev} selected={selected} />}
        {page === 4 && (
          <WizardFormStepFour account={account} campaignInfo={createdCampaignInfo} prev={prev} hasCard={hasCard} handleAddCard={handleAddCard} />
        )}
      </PanelGroup>
    );
  }
}

export default connect()(WizardForm);
